import { BoardItemCardList } from 'components/boardPage/BoardItemCardList'
import { PopupProvider } from 'components/common/Popup'
import { useTheme } from 'components/common/Theme'
import { ExtensionContextProvider, useExtensionContext } from 'hooks/ExtensionContext'
import { useBoard } from 'hooks/useBoard'

export const BoardPage: React.FC = () => (
    <ExtensionContextProvider>
        <BoardPageContent />
    </ExtensionContextProvider>
)

const BoardPageContent: React.FC = () => {
    const state = useExtensionContext()
    const board = useBoard()
    useTheme(state.isDark)
    return (
        <PopupProvider>
            <BoardItemCardList
                user={state.user}
                board={board.state}
                isLogin={state.isLogin}
                authorize={board.authorize}
                loadMore={board.loadMore} />
        </PopupProvider>
    )
}
